export default "__VITE_ASSET__Ce1HW0CT__"